import { render, staticRenderFns } from "./EditExercise.vue?vue&type=template&id=34341d3b&"
import script from "./EditExercise.vue?vue&type=script&lang=js&"
export * from "./EditExercise.vue?vue&type=script&lang=js&"
import style0 from "./EditExercise.vue?vue&type=style&index=0&id=34341d3b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports